class Config {

  constructor (config) {
    this.config = config
    // console.log('config is', this.config)
  }

  _getConfig (key) {
    if (this.config && this.config[key]) {
      return this.config[key]
    }
    return null
  }

  getConfig () {
    return this.config
  }

  getCategoriesConfig () {
    return this._getConfig('categories')
  }

  getSettingsConfig () {
    return this._getConfig('settings')
  }

  getOverlayConfig () {
    return this._getConfig('overlays')
  }

  getCssUrl () {
    return this._getConfig('css')
  }

}

export default Config



// WEBPACK FOOTER //
// ./src/data/Config.js